"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionResponse = void 0;
/**
 * It represents an attempt question response
 *
 * @property {string}        externalResponseId     - unique identifier for the external response
 * @property {string}        externalQuestionId     - unique identifier for the external question
 * @property {number}        score                  - score obtained
 * @property {number}        maxScore               - possible maximum score
 * @property {boolean}       attempted              - if the questions were answered
 *
 * @author javier.perez
 */
var QuestionResponse = /** @class */ (function () {
    function QuestionResponse(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    Object.defineProperty(QuestionResponse.prototype, "isCorrect", {
        get: function () {
            return this.score === this.maxScore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionResponse.prototype, "isPartiallyCorrect", {
        get: function () {
            return this.score > 0 && this.score !== this.maxScore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionResponse.prototype, "isIncorrect", {
        get: function () {
            return this.score === 0 && this.attempted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionResponse.prototype, "graded", {
        get: function () {
            return this.score !== null && this.score !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    return QuestionResponse;
}());
exports.QuestionResponse = QuestionResponse;
